<template xmlns:integration-popup="http://www.w3.org/1999/html">
  <div>
    <integration-popup
      v-if="show"
      :show="show"
      :integration-name="'google'"
      :settings-sync="settingsSync"
      :existed-links="existedLinks"
      @closePopup="handleCancel"
      @createOrUpdateLink="handleCreateOrUpdate"
    />
  </div>
</template>

<script>
import globalToast from '$$vueCmp/toast';
import IntegrationPopup from '../googleOutlookIntegrations/integrationPopup.vue';

export default {
  name: 'GoogleIntegrationPopup',
  components: {
    IntegrationPopup,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    settingsSync: {
      type: Object,
      required: false,
      default: null,
    },
  },
  emits: [
    'closePopup',
    'linkCreated',
  ],
  data() {
    return {
      locale: __,

    };
  },
  computed: {
    existedLinks() {
      return this.$store.getters['integrationGoogle/googleLinks'] || [];
    },
  },
  methods: {
    handleCreateOrUpdate(data) {
      if (this.settingsSync) {
        this.$store.dispatch('integrationGoogle/updateLink', { id: this.settingsSync.id, data })
          .then(() => {
            globalToast.success(this.locale('integration_link_updated'));
            this.$emit('closePopup');
          });
      } else {
        this.$store.dispatch('integrationGoogle/createLink', { data })
          .then(response => {
            userExtAnalytics.log('integration_google_calendar_connected', { type: data.connectionType });

            this.$emit('linkCreated', response);

            this.$emit('closePopup');
          });
      }
    },
    handleCancel() {
      this.$emit('closePopup');
    },
  },
};
</script>

<style module src="../googleOutlookIntegrations/googleOutlookIntegration.less"></style>
